module.exports = __webpack_public_path__ + "img/doorLogo27.3c97b2e5.png";